import SpecialMenus from "pages/Restaurant/SpecialMenus";

export default function SpecialMenusPage() {
  return <SpecialMenus />;
}
